import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import Intro from 'components/common/Intro';
import Globe from 'components/common/globe';
import DownloadModule from 'components/common/DownloadModule';
import Footer from 'components/common/Footer';
import VideoModal from 'components/common/home/VideoModal';

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    // Bindings
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentWillMount() {
    this.props.getCountries();
    this.props.getHomeContent();
  }

  onDownload() {
    this.props.router.push('/publications-data/global-report');
  }

  handleCountrySelect(country) { // eslint-disable-line
    const { iso } = country;

    const route = `/country-profiles/${iso}`;
    this.props.router.push(route);
  }

  handleScroll() {
    if (!this.wrapperContainer) return;
    const wrapContainer = this.wrapperContainer;
    if (wrapContainer) {
      this.wrapperContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  render() {
    const { home } = this.props;
    return (
      <div className="l-main -home" >
        <Intro section="home" size="large">
          <div className="row align-center">
            <div className="column small-12 large-7">
              <h1 className="title -section-title -light">{home.Intro && home.Intro.title}</h1>
              <p className="-light -center home-subtitle">{home.Intro && home.Intro.text}</p>
            </div>
            <div className="small-10 large-5">
              <VideoModal />
            </div>
          </div>
        </Intro>
        {home['Country Profiles'] &&
          <div className="l-section -home-section -large -center">
            <div className="row align-middle">
              <div className="column small-12 medium-6">
                {Object.keys(this.props.countries).length > 0 &&
                  <Globe
                    theme="-home"
                    includeLegend
                    countries={this.props.countries}
                    handleSelection={(val) => { this.handleCountrySelect(val); }}
                    interactivity
                  />
                }
              </div>
              <div className="column small-12 medium-6">
                <h2 className="title">{home['Country Profiles'].title}</h2>
                <p>{home['Country Profiles'].text}</p>
                {home['Country Profiles']['link-text'] && home['Country Profiles']['link-text'] !== '' &&
                  <Link className="btn -large -white" to={home['Country Profiles']['link-url']}>
                    {home['Country Profiles']['link-text']}
                  </Link>
                }
              </div>
            </div>
          </div>
        }
        {home['Country Spotlight'] &&
          <div className="l-section -large -center -spotlight">
            <div className="row">
              <div className="column small-12 medium-6 -country">
                <p className="-light country-spotlight">{home['Country Spotlight'].subtitle}</p>
                <h2 className="-light country-spotlight-title">{home['Country Spotlight'].title}</h2>
                <p className="-light">{home['Country Spotlight'].text}</p>
                {home['Country Spotlight']['link-text'] && home['Country Spotlight']['link-text'] !== '' &&
                  <Link className="btn -light" to={home['Country Spotlight']['link-url']}>
                    {home['Country Spotlight']['link-text']}
                  </Link>
                }
              </div>
            </div>
          </div>
        }
        {home.Download &&
          <DownloadModule
            title={home.Download.title}
            description={home.Download.text}
            onDownload={!!home.Download['link-url'] ? null : () => this.onDownload()}
            buttonText={home.Download['link-text']}
            buttonUrl={home.Download['link-url']}
          />
        }
        <button
          onClick={this.handleScroll}
          className=" -small bg-primary scroll-button"
        >
          <svg width="24" height="24" color="white" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path stroke="white" strokeWidth="2" d="M23.245 4l-11.245 14.374-11.219-14.374-.781.619 12 15.381 12-15.391-.755-.609z" /></svg>
        </button>
        <div ref={(node) => { this.wrapperContainer = node; }} >
          <Footer />
        </div>
      </div>
    );
  }
}

HomePage.propTypes = {
  router: PropTypes.object,
  countries: PropTypes.object,
  home: PropTypes.object,
  mapsLoading: PropTypes.bool,
  // Actions
  getCountries: PropTypes.func,
  getHomeContent: PropTypes.func
};

HomePage.defaultProps = {
  countries: {}
};

export default withRouter(HomePage);



// WEBPACK FOOTER //
// ./app/components/home/index.jsx